import React from 'react';
// 1. ✅ Import NavLink, Outlet, and useNavigate
import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import './AdminLayout.css'; // 2. ✅ We will create this CSS file next

const AdminLayout = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.clear(); 
    navigate('/login');
  };

  return (
    <div className="admin-layout">
      {/* 3. This is the Sidebar */}
      <div className="sidebar">
        <h3 className="sidebar-title">Admin Panel</h3>
        
        {/* 4. This is the main navigation */}
        <nav className="sidebar-nav">
          <NavLink to="/admin/home"> Home</NavLink>
          <NavLink to="/admin/dashboard">Manage Blogs</NavLink>
          <NavLink to="/admin/careers">Manage Jobs</NavLink>
          <NavLink to="/admin/applicants">View Applicants</NavLink>
          <NavLink to="/admin/gallery">Manage Gallery</NavLink>
          <NavLink to="/admin/messages">Manage Inquiry</NavLink>
        </nav>
        
        {/* 5. The Logout button is at the bottom */}
        <div className="sidebar-footer">
          <button onClick={handleLogout} className="logout-button">
            Logout
          </button>
        </div>
      </div>

      {/* 6. This is the main content area where your pages will render */}
      <div className="main-content">
        {/* <Outlet> renders the active child route (BlogList, JobList, etc.) */}
        <Outlet />
      </div>
    </div>
  );
};

export default AdminLayout;